const augistine = [
  {
    id: "1",
    colorName: "White Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_White.png?v=1587494179',
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_White.png?v=1587063208",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_White.png?v=1587063200",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_White.png?v=1587063202",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_White.png?v=1587063204",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_White.png?v=1587063213",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_White.png?v=1587063208"
  },
  {
    id: "2",
    colorName: "Bisque Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Bisque.png?v=1587494180',
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Bisque.png?v=1587063156",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_Bisque.png?v=1587063227",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_Bisque.png?v=1587063231",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_Bisque.png?v=1587063233",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_Bisque.png?v=1587063230",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_Bisque.png?v=1587063234"
  },
  {
    id: "3",
    colorName: "Gray Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Gray.png?v=1587494180',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Gray.png?v=1587063219",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_Gray.png?v=1587063220",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_Gray.png?v=1587063224",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_Gray.png?v=1587063225",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_Gray.png?v=1587063226",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_Gray.png?v=1587063228"
  },
  {
    id: "4",
    colorName: "Black Melamine*",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Black.png?v=1587494180',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Black.png?v=1587063156",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_Black.png?v=1587063227",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_Black.png?v=1587063229",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_Black.png?v=1587063231",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_Black.png?v=1587063228",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_Black.png?v=1587063232"
  },
  {
    id: "5",
    colorName: "Hudson Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_HudsonCherry.png?v=1587494180',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_HudsonCherry.png?v=1587063226",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_HudsonCherry.png?v=1587063232",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_HudsonCherry.png?v=1587063234",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_HudsonCherry.png?v=1587063236",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_HudsonCherry.png?v=1587063232",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_HudsonCherry.png?v=1587063237"
  },
  {
    id: "6",
    colorName: "Nina Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Nina.png?v=1587494181',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Nina.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_Nina.png?v=1587063232",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_Nina.png?v=1587063236",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_Nina.png?v=1587063238",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_Nina.png?v=1587063233",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_Nina.png?v=1587063238"
  },
  {
    id: "7",
    colorName: "Clark Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Clark.png?v=1587494181',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Clark.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_Clark.png?v=1587063234",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_Clark.png?v=1587063237",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_Clark.png?v=1587063237",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_Clark.png?v=1587063235",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_Clark.png?v=1587063238"
  },
  {
    id: "8",
    colorName: "Lauren Mahogany Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_LaurenMahogany.png?v=1587494180',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_LaurenMahogany.png?v=1587063226",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_LaurenMahogany.png?v=1587063231",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_LaurenMahogany.png?v=1587063235",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_LaurenMahogany.png?v=1587063237",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_LaurenMahogany.png?v=1587063233",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_LaurenMahogany.png?v=1587063237"
  },
  {
    id: "9",
    colorName: "Gordon Cherry Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_GordonCherry.png?v=1587494180',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_GordanCherry.png?v=1587063226",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_GordanCherry.png?v=1587063231",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_GordanCherry.png?v=1587063234",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_GordanCherry.png?v=1587063236",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_GordanCherry.png?v=1587063232",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_GordanCherry.png?v=1587063237"
  },
  {
    id: "10",
    colorName: "Chocolate Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Chocolate.png?v=1587494180',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Chocolate.png?v=1587063171",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_Chocolate.png?v=1587063231",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_Chocolate.png?v=1587063234",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_Chocolate.png?v=1587063236",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_Chocolate.png?v=1587063232",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_Chocolate.png?v=1587063237"
  },
  {
    id: "11",
    colorName: "Marseille Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Marseille.png?v=1587494181',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Marseille.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_Marseille.png?v=1587063234",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_Marseille.png?v=1587063237",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_Marseille.png?v=1587063237",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_Marseille.png?v=1587063235",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_Marseille.png?v=1587063238"
  },
  {
    id: "12",
    colorName: "Monaco Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Monaco.png?v=1587494181',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Monaco.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_Monaco.png?v=1587063233",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_Monaco.png?v=1587063236",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_Monaco.png?v=1587063238",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_Monaco.png?v=1587063235",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_Monaco.png?v=1587063238"
  },
  {
    id: "13",
    colorName: "Naples Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Naples.png?v=1587494180',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Naples.png?v=1587063224",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_Naples.png?v=1587063229",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_Naples.png?v=1587063233",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_Naples.png?v=1587063235",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_Naples.png?v=1587063230",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_Naples.png?v=1587063236"
  },
  {
    id: "14",
    colorName: "Real Wood Maple Veneer",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_RealWood.png?v=1587494180',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_RealWood.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_RealWood.png?v=1587063232",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_RealWood.png?v=1587063235",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_RealWood.png?v=1587063237",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_RealWood.png?v=1587063233",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_StAugustine_RealWood.png?v=1587063237"
  }
];

const daytona = [
  {
    id: "1",
    colorName: "White Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_White.png?v=1587494179',
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_White.png?v=1587063208",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_White.png?v=1587063199",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_White.png?v=1587063201",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_White.png?v=1587063203",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_White.png?v=1587063212",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_White.png?v=1587063213"
  },
  {
    id: "2",
    colorName: "Bisque Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Bisque.png?v=1587494180',
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Bisque.png?v=1587063156",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_Bisque.png?v=1587063226",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_Bisque.png?v=1587063231",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_Bisque.png?v=1587063233",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_Bisque.png?v=1587063230",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_Bisque.png?v=1587063235"
  },
  {
    id: "3",
    colorName: "Gray Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Gray.png?v=1587494180',
    price: 5,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Gray.png?v=1587063219",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_Gray.png?v=1587063223",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_Gray.png?v=1587063227",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_Gray.png?v=1587063228",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_Gray.png?v=1587063225",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_Gray.png?v=1587063230"
  },
  {
    id: "4",
    colorName: "Black Melamine*",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Black.png?v=1587494180',
    price: 5,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Black.png?v=1587063156",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_Black.png?v=1587063226",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_Black.png?v=1587063229",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_Black.png?v=1587063231",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_Black.png?v=1587063228",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_Black.png?v=1587063232"
  },
  {
    id: "5",
    colorName: "Hudson Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_HudsonCherry.png?v=1587494180',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_HudsonCherry.png?v=1587063226",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_HudsonCherry.png?v=1587063231",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_HudsonCherry.png?v=1587063234",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_HudsonCherry.png?v=1587063236",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_HudsonCherry.png?v=1587063233",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_HudsonCherry.png?v=1587063237"
  },
  {
    id: "6",
    colorName: "Nina Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Nina.png?v=1587494181',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Nina.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_Nina.png?v=1587063232",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_Nina.png?v=1587063236",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_Nina.png?v=1587063238",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_Nina.png?v=1587063233",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_Nina.png?v=1587063237"
  },
  {
    id: "7",
    colorName: "Clark Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Clark.png?v=1587494181',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Clark.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_Clark.png?v=1587063234",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_Clark.png?v=1587063237",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_Clark.png?v=1587063238",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_Clark.png?v=1587063235",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_Clark.png?v=1587063237"
  },
  {
    id: "8",
    colorName: "Lauren Mahogany Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_LaurenMahogany.png?v=1587494180',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_LaurenMahogany.png?v=1587063226",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_LaurenMahogany.png?v=1587063231",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_LaurenMahogany.png?v=1587063235",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_LaurenMahogany.png?v=1587063237",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_LaurenMahogany.png?v=1587063233",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_LaurenMahogany.png?v=1587063237"
  },
  {
    id: "9",
    colorName: "Gordon Cherry Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_GordonCherry.png?v=1587494180',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_GordanCherry.png?v=1587063226",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_GordanCherry.png?v=1587063231",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_GordanCherry.png?v=1587063235",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_GordanCherry.png?v=1587063236",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_GordanCherry.png?v=1587063233",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_GordanCherry.png?v=1587063237"
  },
  {
    id: "10",
    colorName: "Chocolate Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Chocolate.png?v=1587494180',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Chocolate.png?v=1587063171",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_Chocolate.png?v=1587063231",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_Chocolate.png?v=1587063234",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_Chocolate.png?v=1587063236",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_Chocolate.png?v=1587063232",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_Chocolate.png?v=1587063236"
  },
  {
    id: "11",
    colorName: "Marseille Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Marseille.png?v=1587494181',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Marseille.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_Marseille.png?v=1587063234",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_Marseille.png?v=1587063237",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_Marseille.png?v=1587063237",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_Marseille.png?v=1587063235",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_Marseille.png?v=1587063238"
  },
  {
    id: "12",
    colorName: "Monaco Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Monaco.png?v=1587494181',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Monaco.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_Monaco.png?v=1587063234",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_Monaco.png?v=1587063236",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_Monaco.png?v=1587063237",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_Monaco.png?v=1587063235",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_Monaco.png?v=1587063238"
  },
  {
    id: "13",
    colorName: "Naples Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Naples.png?v=1587494180',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Naples.png?v=1587063224",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_Naples.png?v=1587063229",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_Naples.png?v=1587063232",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_Naples.png?v=1587063235",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_Naples.png?v=1587063232",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_Naples.png?v=1587063236"
  },
  {
    id: "14",
    colorName: "Real Wood Maple Veneer",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_RealWood.png?v=1587494180',
    price: 50,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_RealWood.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Daytona_RealWood.png?v=1587063232",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Daytona_RealWood.png?v=1587063235",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Daytona_RealWood.png?v=1587063237",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Daytona_RealWood.png?v=1587063233",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Daytona_RealWood.png?v=1587063237"
  }
];

const bahama = [
  {
    id: "1",
    colorName: "White Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_White.png?v=1587494179',
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_White.png?v=1587063208",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_White.png?v=1587063200",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_White.png?v=1587063202",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_White.png?v=1587063204",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_White.png?v=1587063212",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_White.png?v=1587063207"
  },
  {
    id: "2",
    colorName: "Bisque Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Bisque.png?v=1587494180',
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Bisque.png?v=1587063156",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_Bisque.png?v=1587063226",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_Bisque.png?v=1587063231",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_Bisque.png?v=1587063233",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_Bisque.png?v=1587063230",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_Bisque.png?v=1587063235"
  },
  {
    id: "3",
    colorName: "Gray Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Gray.png?v=1587494180',
    price: 5,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Gray.png?v=1587063219",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_Gray.png?v=1587063224",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_Gray.png?v=1587063224",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_Gray.png?v=1587063228",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_Gray.png?v=1587063225",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_Gray.png?v=1587063229"
  },
  {
    id: "4",
    colorName: "Black Melamine*",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Black.png?v=1587494180',
    price: 5,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Black.png?v=1587063156",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_Black.png?v=1587063226",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_Black.png?v=1587063229",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_Black.png?v=1587063231",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_Black.png?v=1587063228",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_Black.png?v=1587063232"
  },
  {
    id: "5",
    colorName: "Hudson Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_HudsonCherry.png?v=1587494180',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_HudsonCherry.png?v=1587063226",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_HudsonCherry.png?v=1587063231",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_HudsonCherry.png?v=1587063234",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_HudsonCherry.png?v=1617208850",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_HudsonCherry.png?v=1587063232",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_HudsonCherry.png?v=1587063237"
  },
  {
    id: "6",
    colorName: "Nina Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Nina.png?v=1587494181',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Nina.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_Nina.png?v=1587063232",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_Nina.png?v=1587063236",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_Nina.png?v=1587063238",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_Nina.png?v=1587063233",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_Nina.png?v=1587063237"
  },
  {
    id: "7",
    colorName: "Clark Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Clark.png?v=1587494181',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Clark.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_Clark.png?v=1587063234",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_Clark.png?v=1587063236",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_Clark.png?v=1587063238",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_Clark.png?v=1587063235",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_Clark.png?v=1587063238"
  },
  {
    id: "8",
    colorName: "Lauren Mahogany Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_LaurenMahogany.png?v=1587494180',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_LaurenMahogany.png?v=1587063226",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_LaurenMahogany.png?v=1587063231",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_LaurenMahogany.png?v=1587063235",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_LaurenMahogany.png?v=1587063237",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_LaurenMahogany.png?v=1587063232",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_LaurenMahogany.png?v=1587063237"
  },
  {
    id: "9",
    colorName: "Gordon Cherry Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_GordonCherry.png?v=1587494180',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_GordanCherry.png?v=1587063226",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_GordanCherry.png?v=1587063231",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_GordanCherry.png?v=1587063235",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_GordanCherry.png?v=1587063236",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_GordanCherry.png?v=1587063232",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_GordanCherry.png?v=1587063237"
  },
  {
    id: "10",
    colorName: "Chocolate Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Chocolate.png?v=1587494180',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Chocolate.png?v=1587063171",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_Chocolate.png?v=1587063231",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_Chocolate.png?v=1587063234",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_Chocolate.png?v=1587063236",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_Chocolate.png?v=1587063232",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_Chocolate.png?v=1587063237"
  },
  {
    id: "11",
    colorName: "Marseille Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Marseille.png?v=1587494181',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Marseille.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_Marseille.png?v=1587063234",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_Marseille.png?v=1587063237",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_Marseille.png?v=1587063238",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_Marseille.png?v=1587063235",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_Marseille.png?v=1587063237"
  },
  {
    id: "12",
    colorName: "Monaco Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Monaco.png?v=1587494181',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Monaco.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_Monaco.png?v=1587063232",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_Monaco.png?v=1587063236",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_Monaco.png?v=1587063237",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_Monaco.png?v=1587063235",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_Monaco.png?v=1587063238"
  },
  {
    id: "13",
    colorName: "Naples Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Naples.png?v=1587494180',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Naples.png?v=1587063224",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_Naples.png?v=1587063229",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_Naples.png?v=1587063233",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_Naples.png?v=1587063235",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_Naples.png?v=1587063232",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_Naples.png?v=1587063236"
  },
  {
    id: "14",
    colorName: "Real Wood Maple Veneer",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_RealWood.png?v=1587494180',
    price: 50,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_RealWood.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Shaker_RealWood.png?v=1587063232",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Shaker_RealWood.png?v=1587063235",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Shaker_RealWood.png?v=1587063237",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Shaker_RealWood.png?v=1587063233",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Shaker_RealWood.png?v=1587063237"
  }
];

const anastasia = [
  {
    id: "1",
    colorName: "White Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_White.png?v=1587494179',
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_White.png?v=1587063208",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_White.png?v=1617209028",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_White.png?v=1616703774",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_White.png?v=1616703774",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_White.png?v=1616703776",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_White.png?v=1616703775"
  },
  {
    id: "2",
    colorName: "Bisque Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Bisque.png?v=1587494180',
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Bisque.png?v=1587063156",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_Bisque.png?v=1616703775",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_Bisque.png?v=1616703780",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_Bisque.png?v=1616703780",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_Bisque.png?v=1616703779",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_Bisque.png?v=1616703780"
  },
  {
    id: "3",
    colorName: "Gray Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Gray.png?v=1587494180',
    price: 5,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Gray.png?v=1587063219",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_Gray.png?v=1616703772",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_Gray.png?v=1616703777",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_Gray.png?v=1616703778",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_Gray.png?v=1616703778",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_Gray.png?v=1616703780"
  },
  {
    id: "4",
    colorName: "Black Melamine*",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Black.png?v=1587494180',
    price: 5,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Black.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_Black.png?v=1616703774",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_Black.png?v=1616703778",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_Black.png?v=1616703779",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_Black.png?v=1616703779",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_Black.png?v=1616703780"
  },
  {
    id: "5",
    colorName: "Hudson Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_HudsonCherry.png?v=1587494180',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_HudsonCherry.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_HudsonCherry.png?v=1616703777",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_HudsonCherry.png?v=1616703781",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_HudsonCherry.png?v=1616703781",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_HudsonCherry.png?v=1616703780",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_HudsonCherry.png?v=1616703781"
  },
  {
    id: "6",
    colorName: "Nina Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Nina.png?v=1587494181',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Nina.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_Nina.png?v=1616703779",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_Nina.png?v=1616703781",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_Nina.png?v=1616703782",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_Nina.png?v=1616703781",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_Nina.png?v=1616703782"
  },
  {
    id: "7",
    colorName: "Clark Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Clark.png?v=1587494181',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Clark.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_Clark.png?v=1616703777",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_Clark.png?v=1616703782",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_Clark.png?v=1616703782",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_Clark.png?v=1616703781",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_Clark.png?v=1616703782"
  },
  {
    id: "8",
    colorName: "Lauren Mahogany Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_LaurenMahogany.png?v=1587494180',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_LaurenMahogany.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_LaurenMahogany.png?v=1616703777",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_LaurenMahogany.png?v=1616703781",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_LaurenMahogany.png?v=1616703781",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_LaurenMahogany.png?v=1616703780",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_LaurenMahogany.png?v=1616703782"
  },
  {
    id: "9",
    colorName: "Gordon Cherry Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_GordonCherry.png?v=1587494180',
    price: 10,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_GordanCherry.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_GordanCherry.png?v=1616703777",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_GordanCherry.png?v=1616703781",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_GordanCherry.png?v=1616703781",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_GordanCherry.png?v=1616703780",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_GordanCherry.png?v=1616703782"
  },
  {
    id: "10",
    colorName: "Chocolate Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Chocolate.png?v=1587494180',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Chocolate.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_Chocolate.png?v=1616703777",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_Chocolate.png?v=1616703781",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_Chocolate.png?v=1616703781",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_Chocolate.png?v=1616703780",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_Chocolate.png?v=1616703781"
  },
  {
    id: "11",
    colorName: "Marseille Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Marseille.png?v=1587494181',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Marseille.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_Marseille.png?v=1616703779",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_Marseille.png?v=1616703782",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_Marseille.png?v=1616703782",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_Marseille.png?v=1616703781",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_Marseille.png?v=1616703782"
  },
  {
    id: "12",
    colorName: "Monaco Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Monaco.png?v=1587494181',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Monaco.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_Monaco.png?v=1616703779",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_Monaco.png?v=1616703781",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_Monaco.png?v=1616703782",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_Monaco.png?v=1616703780",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_Monaco.png?v=1616703782"
  },
  {
    id: "13",
    colorName: "Naples Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Naples.png?v=1587494180',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Naples.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_Naples.png?v=1616703778",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_Naples.png?v=1616703780",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_Naples.png?v=1616703781",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_Naples.png?v=1616703781",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_Naples.png?v=1616703781"
  },
  {
    id: "14",
    colorName: "Real Wood Maple Veneer",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_RealWood.png?v=1587494180',
    price: 50,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_RealWood.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_RealWood.png?v=1616703780",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_RealWood.png?v=1616703781",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_RealWood.png?v=1616703782",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_RealWood.png?v=1616703781",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_RealWood.png?v=1616703782"
  }
];

const boaz = [
  {
    id: "1",
    colorName: "White Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/BOAZ_V2_WHITE_OPEN_Medium_554d9a69-270e-45d9-ab08-584580ab3eff.png?v=1754934922',
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_White.png?v=1587063208",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_White.png?v=1617209028",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_White.png?v=1616703774",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_White.png?v=1616703774",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_White.png?v=1616703776",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_White.png?v=1616703775"
  },
  {
    id: "3",
    colorName: "Black Melamine*",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/BOAZ_V2_BLACK_OPEN_Medium_9094caed-4a2c-4eb2-8b7c-34134b089b3c.png?v=1754934922',
    price: 5,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Black.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_Black.png?v=1616703774",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_Black.png?v=1616703778",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_Black.png?v=1616703779",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_Black.png?v=1616703779",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_Black.png?v=1616703780"
  },  
  {
    id: "4",
    colorName: "Gray Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/BOAZ_V2_GRAY_OPEN_Medium_02986cfd-a5d4-484a-910a-7cc85e7d2dba.png?v=1754934922',
    price: 5,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Gray.png?v=1587063219",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_Gray.png?v=1616703772",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_Gray.png?v=1616703777",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_Gray.png?v=1616703778",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_Gray.png?v=1616703778",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_Gray.png?v=1616703780"
  },
  {
    id: "6",
    colorName: "Monaco Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/BOAZ_V2_MONACO_OPEN_Medium_87c6c2d4-6863-4137-a83e-840919900689.png?v=1754934922',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Monaco.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_Monaco.png?v=1616703779",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_Monaco.png?v=1616703781",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_Monaco.png?v=1616703782",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_Monaco.png?v=1616703780",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_Monaco.png?v=1616703782"
  },
  {
    id: "11",
    colorName: "Chocolate Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/BOAZ_V2_CHOCOLATE_OPEN_Medium_0bd232df-823c-4038-91c2-70e7e7ee40d5.png?v=1754934922',
    price: 25,
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Chocolate.png",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_Anastasia_Chocolate.png?v=1616703777",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_Anastasia_Chocolate.png?v=1616703781",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_Anastasia_Chocolate.png?v=1616703781",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_Anastasia_Chocolate.png?v=1616703780",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_J_Anastasia_Chocolate.png?v=1616703781"
  }
];
const homeoffice = [
  {
    id: "1",
    colorName: "White Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/PANEL_BED-WHITE-OPEN.png?v=1754934670',
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_White.png?v=1587063208",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_White.png?v=1587063200",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_White.png?v=1587063202",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_White.png?v=1587063204",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/WHITE-H-STAUG.png?v=1755620104",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/WHITE-J-STAUG.png?v=1755620104"
  },
  {
    id: "3",
    colorName: "Gray Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Gray.png?v=1587494180',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Gray.png?v=1587063219",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/GRAY-B-STAUG.png?v=1755620103",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_Gray.png?v=1587063224",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_Gray.png?v=1587063225",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_Gray.png?v=1587063226",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/GRAY-J-STAUG.png?v=1755620104"
  },
  {
    id: "4",
    colorName: "Black Melamine*",
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Black.png?v=1587063156",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_Black.png?v=1587063227",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_Black.png?v=1587063229",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_Black.png?v=1587063231",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_H_StAugustine_Black.png?v=1587063228",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/BLACK-J-STAUG.png?v=1755620104"
  },
  {
    id: "10",
    colorName: "Chocolate Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Chocolate.png?v=1587494180',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Chocolate.png?v=1587063171",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_B_StAugustine_Chocolate.png?v=1587063231",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_Chocolate.png?v=1587063234",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_Chocolate.png?v=1587063236",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/CHOCOLATE-H-STAUG.png?v=1755620104",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/CHOCOLATE-J-STAUG.png?v=1755620104"
  },
  {
    id: "12",
    colorName: "Monaco Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_Bed_Open_Monaco.png?v=1587494181',
    
    A:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_A_StAugustine_Monaco.png?v=1587063228",
    B:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MONACO-B-STAUG.png?v=1755620104",
    C:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_C_StAugustine_Monaco.png?v=1587063236",
    D:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MBD_SCab_D_StAugustine_Monaco.png?v=1587063238",
    H:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MONACO-H-STAUG.png?v=1755620104",
    J:
      "https://cdn.shopify.com/s/files/1/1786/1333/files/MONACO-J-STAUG.png?v=1755620104"
  },
  ];
  const deluxe = [
  {
    id: "1",
    colorName: "White Melamine",
    openView: 'hhttps://cdn.shopify.com/s/files/1/1786/1333/files/WHITE-_OPEN_Custom.png?v=1755721620',
  },
  {
    id: "3",
    colorName: "Gray Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/GRAY-_OPEN_Custom.png?v=1755721620',
  },
  {
    id: "4",
    colorName: "Black Melamine*",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/BLACK-_OPEN_Custom.png?v=1755721620',
  },
  {
    id: "10",
    colorName: "Chocolate Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/CHOCOLATE-_OPEN_Custom.png?v=1755721620',
  },
  {
    id: "12",
    colorName: "Monaco Textured Melamine",
    openView: 'https://cdn.shopify.com/s/files/1/1786/1333/files/MONACO-_OPEN_Custom.png?v=1755721620',
  },
];


const dataset = {
  augistine,
  daytona,
  bahama,
  anastasia,
  boaz,
  homeoffice,
  deluxe,
};

const datasetIds = {
  '8632354065': augistine,
  '6916114383013':augistine,
  '8116613513381':augistine,
  '8796025297': daytona,
  '8805375057': bahama,
  '6070757228709': anastasia,
  '3800275157064': anastasia,
  '8632354001': boaz,
  '5619901956261': homeoffice,
  '14780162441588': homeoffice,
  '': deluxe,
};

window.dataset = dataset || {};
window.datasetIds = datasetIds || {};
